import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

import AppBar from './components/sections/AppBar.js';
import Home from './components/pages/Home.js';
import PrivacyPolicy from './components/pages/PrivacyPolicy.js';
import Footer from './components/sections/Footer.js';
import DeleteAccount from './components/pages/DeleteAccount.js';
import StudentLogin from './components/pages/StudentLogin.js';
import StudentHome from './components/pages/StudentHome.js';
import AssessmentDetail from './components/pages/AssessmentDetail.js';
import Questions from './components/pages/Questions.js';
import AssessmentResult from './components/pages/AssessmentResult.js';


function App() {

  return (
    <Box>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AppContent />
      </Router>
    </Box>
  );
}

function AppContent() {
  const location = useLocation();
  
  // Pages without AppBar and Footer
  const hideLayoutPages = [
    '/student-login',
    '/student-home',
  ];
  
  // Check if current path starts with any hideLayoutPages path
  const shouldHideLayout = hideLayoutPages.some(path => 
    location.pathname === path || location.pathname.startsWith('/student/')
  );

  return (
    <div className="App">
      {!shouldHideLayout && (
        <Box width={"100%"} position={"fixed"} top={0} zIndex={9999}>
          <AppBar />
        </Box>
      )}

      <Routes>
        <Route path="" element={<Home />} />
        <Route path="/" element={<Home />} />
        <Route path="/Home" element={<Home />} />
        <Route path="/TermsAndConditions" element={<Home />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/DeleteAccount" element={<DeleteAccount />} />
        <Route path="/student-login" element={<StudentLogin />} />
        <Route path="/student-home" element={<StudentHome />} />
        <Route path="/student/assessment/:assessmentId" element={<AssessmentDetail />} />
        <Route path="/student/assessment/:assessmentId/questions" element={<Questions />} />
        <Route path="/student/assessment/:assessmentId/result" element={<AssessmentResult />} />
        {/* Add more routes here as needed */}
      </Routes>

      {!shouldHideLayout && (
        <Box id="footer" py={7} pb={7} sx={{ width: '100%', backgroundColor: '#fff5f0' }}>
          <Container>
            <Footer />
          </Container>         
        </Box>
      )}
    </div>
  );
}

export default App;